export default "__VITE_ASSET__C7x973zh__"